<template>
  <div>
    <pdl-section-header size="sm" :is-dividing="true" class="pt-2 lg:pt-0 hidden lg:block">
      <template #content>
        <pdl-heading :level="headingLevel">
          {{ title }}
        </pdl-heading>
      </template>
    </pdl-section-header>
    <pdl-button
      v-if="!totalFiltersSelected && isOpen"
      secondary
      block
      icon-only
      icon="highlight_off"
      class="lg:hidden my-2"
      :aria-label="$t('search.nav.done.button')"
      @click="toggleFilterVisibility"
    >
    </pdl-button>
    <pdl-button v-else-if="isOpen" primary block class="lg:hidden my-2" @click="toggleFilterVisibility">
      <span>{{ $t('search.nav.done.button') }}</span>
    </pdl-button>
  </div>
</template>

<script>
import {PdlSectionHeader, PdlHeading} from '@pedal/pdl-section-header';
import {PdlButton} from '@pedal/pdl-button';

export default {
  name: 'FacetsHeader',

  components: {PdlSectionHeader, PdlHeading, PdlButton},

  props: {
    selectedFilters: {
      type: [Array, Object],
      default: () => [],
    },
    title: {
      type: String,
      required: true,
    },
    headingLevel: {
      type: Number,
      default: 3,
      required: false,
    },
    isOpen: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    totalFiltersSelected() {
      return !this.selectedFilters ? 0 : this.selectedFilters.length;
    },
  },
  methods: {
    toggleFilterVisibility() {
      this.$emit('toggle-state');
    },
  },
};
</script>
